import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var BellOff01 = function BellOff01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M8.633 3.0337A6.0001 6.0001 0 0 1 18 8c0 2.1008.2702 3.7512.6484 5.0324M6.2587 6.2572A6 6 0 0 0 6 8c0 3.0902-.7795 5.206-1.6503 6.6054-.7346 1.1805-1.1018 1.7707-1.0884 1.9354.015.1823.0536.2518.2005.3608C3.5945 17 4.1926 17 5.3888 17H17m-7.6458 4c.7051.6224 1.6314 1 2.6458 1a3.985 3.985 0 0 0 2.6458-1M21 21 3 3"
    })
  }));
};
export default BellOff01;